module.exports = __webpack_public_path__ + "static/media/48369030_2308812369193941_9203383804520038400_o.4461a2eb.jpg";